document.addEventListener("DOMContentLoaded", function () {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      printLog(`Running a check on ${cart.items.length} cart item(s)`);

      if (!cart.items.length) {
        return;
      }

      const payload = getInvalidCartItemsPayload(cart.items);
      removeCartItems(payload);
    });

  function getInvalidCartItemsPayload(items) {
    const payload = {};

    items.forEach((item) => {
      if (!isItemValid(item)) {
        const itemKey = item.key;
        payload[itemKey] = 0;
      }
    });

    return payload;
  }

  function isItemValid(item) {
    if (item.title.toLowerCase().includes("custom box")) {
      // No "Contents" property, this is invalid
      if (typeof item.properties.Contents === "undefined") {
        return false;
      }

      const contentArray = item.properties.Contents.split("\n");

      let isInvalid = false;
      contentArray.forEach((contentItem) => {
        if (contentItem.includes("Sliced Scotch Fillet / Cube Roll 3kg")) {
          isInvalid = true;
        }
      });

      if (isInvalid) {
        return false;
      }
    }

    return true;
  }

  function removeCartItems(payload) {
    const totalInvalidItems = Object.values(payload).length;
    if (totalInvalidItems <= 0) {
      printLog(`✅ All good!`);
      return;
    }
    
    printLog(`⚠️ ${totalInvalidItems} invalid item(s) found.`);

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: payload }),
    })
      .then((response) => {
        return response.json();
      })
      .then(() => {
        location.reload(); // Refresh cart after deletion
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  function printLog(message) {
    console.log(
      `%cCart Sanitizer`, // Console Message
      'font-weight: bold; color: #000; background: #ffcc00; border-radius: 3px; padding-left: 5px; padding-right: 5px;',
      message,
    );
  }
});
